import { render, staticRenderFns } from "./BoardWriteQnaLayout.vue?vue&type=template&id=4be5c406&scoped=true"
import script from "./BoardWriteQnaLayout.vue?vue&type=script&lang=js"
export * from "./BoardWriteQnaLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4be5c406",
  null
  
)

export default component.exports